<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card class="bg-light shadow">
          <b-card-title title-tag="h6">
            Factures
            <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
          </b-card-title>
          <div class="d-flex justify-content-start align-items-center">
            <label class="mx-3 align-self-center">Rechercher : </label>
            <mh-input
              @enter="submitSearch()"
              autofocus
              append="🔍"
              field="search"
              :table="searchTable"
              :autocomplete="{
                field:
                  'facture.ID || facture.type',
              }"
            >
            </mh-input>
            <label class="mx-3 align-self-center">Type : </label>
            <mh-input
              @change="submitSearch()"
              autofocus
              append="🔍"
              field="type"
              :table="searchTable"
            >
            </mh-input>
          </div>
          <b-row v-if="$options.invoices.length > 0" class="mt-3">
            <b-col sm="12" md="12" lg="12" :key="render">
              <list
                @changePage="changePage"
                @removeFilter="removeFilter"
                @changeSort="changeSort"
                :items="$options.invoices"
                :fields="fields"
              >
                <template v-slot:cell(ID)="data">
                  <a :href="getPathUrl(data.item.ID)" target="_blank">
                    {{ data.item.ID }}
                  </a>
                </template>

                <template v-slot:cell(actions)="data">
                  <b-button
                    title="PDF de la facture"
                    icon
                    size="sm"
                    class="btn-xs ml-2"
                    variant="info"
                    target="_blank"
                    :href="getPathUrl(data.item.ID)"
                  >
                    <b-icon-printer-fill></b-icon-printer-fill>
                  </b-button>
                </template>
                <template v-slot:cell(cloture)="data">
                  <h6>
                    <span v-if="data.item.cloture == 'yes'">
                      <b-icon-check-square-fill
                        variant="success"
                      ></b-icon-check-square-fill>
                    </span>
                    <span v-else>
                      <b-icon-x-square-fill
                        variant="danger"
                      ></b-icon-x-square-fill>
                    </span>
                  </h6>
                </template>
              </list>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>          
<script>
import List from "@/components/List";
import DateTime from "@/services/DateTime.js";
import String from "@/services/String.js";
import MhInput from "@/components/MhInput.vue";
import invoices from "@/services/invoices.js";
export default {
  components: {
    List,
    MhInput,
  },
  name: "Invoices",
  invoices: [],
  data() {
    return {
      render: 0,
      invoice_id: null,
      searchTable: {
        search: {
          label: "",
          type: "varchar",
          value: "",
        },
        type: {
          label: "",
          type: "enum",
          value: "all",
          options: [
            {
              value: "all",
              text: "Toutes les factures",
            },
            {
              value: "commission",
              text: "Commission",
            },
            {
              value: "vente",
              text: "Vente",
            },
            {
              value: "note de credit",
              text: "Note de crédit",
            },
            {
              value: "generic",
              text: "Générique",
            },
          ],
        },
      },
      debug: false,
      info: {},
      filters: [],
      page: 1,
      pagination: {},
      loaded: false,
      resultsInfo: false,
      sortBy: "date",
      sortDesc: true,
      busy: false,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Factures",
          active: true,
        },
      ],
      fields: [
        {
          key: "ID",
          label: "N° de facture",
          sortable: true,
          class: "text-right",
          thStyle: "width:100px",
        },

        {
          key: "date",
          label: "Date",
          sortable: true,
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "mandat_prix_unitaire",
          label: "Prix unitaire",
          sortable: true,
          class: "text-right",
          formatter: (value) => {
            return value ? value + " €" : "";
          },
        },
        {
          key: "prixHTVA",
          label: "Prix HTVA",
          sortable: true,
          class: "text-right  font-weight-bold",
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "tva",
          label: "TVA",
          sortable: true,
          class: "text-right",
          formatter: (value, key, item) => {
            return (
              (item.prixHTVA * value).toFixed(2) +
              " € (" +
              item.tva * 100 +
              " %)"
            );
          },
        },
        {
          key: "tvac",
          label: "TVAC",
          sortable: true,
          class: "text-right font-weight-bold",
          formatter: (value, key, item) => {
            return (
              (Number(item.prixHTVA) * (1 + Number(item.tva))).toFixed(2) + " €"
            );
          },
        },
        {
          key: "cloture",
          label: "Cloturée",
          class: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:200px",
          class: "text-center",
        },
      ],
    };
  },
  created() {
    this.search = this.$route.params.search || "";
    this.scroll();
    this.loaded = false;
    this.submitSearch();
  },
  methods: {
    getPathUrl(id) {
      return (
        this.$store.getters.url +
        "/client/invoice/" +
        id +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (
          bottomOfWindow &&
          this.pagination.numberOfPages > this.page &&
          !this.busy
        ) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch();
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },

    continueSearch() {
      this.busy = true;
      invoices
        .search(
          this.searchTable.search.value,
          this.searchTable.type.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc,
          this.activeCreditor
        )
        .then((response) => {
          this.$options.invoices = this.$options.invoices.concat(
            response.data.results.records
          );
          this.pagination = response.data.results.pagination;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
    submitSearch() {
      this.busy = true;
      this.page = 1;

      invoices
        .search(
          this.searchTable.search.value,
          this.searchTable.type.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.invoices = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.resultsInfo = this.pagination.totalRecords;
          this.loaded = true;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>